
import { ActionTypes, IAccountsAction, IAccountsState } from 'app/redux/Accounts/reducer'
import { ActionCreator } from 'app/redux/ActionCreator'
import { AccountsService, CreateResponse, IsValidAuthTokenResponse } from 'app/services/AccountsService'
import { OperationStatus } from 'app/services/OperationStatus'
import { genericFailure } from 'app/services/WebServiceBase'
import { getWebServicesConfig } from 'config'
import * as _ from 'lodash'

class AccountsActionCreator extends ActionCreator<IAccountsState, IAccountsAction> {

  create(username: string, password: string, extraArgs: any): Promise<CreateResponse> {
    this.dispatch(this.userCreateStarting(username))

    // construct the parameters to the server from the
    // username, password and anything else passed
    const args = _.extend({}, { username, password }, extraArgs)

    const svc = new AccountsService(getWebServicesConfig().accountsEndpoint)
    return svc.createUser(args)
      .then((lr: CreateResponse) => {
        this.setSharedVar('accessToken', lr.AccessToken)
        this.dispatch(this.userCreateCompleted(username, lr))
        return lr
      })
      .catch((reason) => {
        this.dispatch(this.userCreateFailed(username, reason))
        return Promise.reject(reason)
      })
  }

  private userCreateStarting = (username: string): IAccountsAction => {
    return {
      type: ActionTypes.USER_CREATE_STARTING,
      account: { username, op: new OperationStatus().setStarting('user account creation starting') }
    }
  }

  private userCreateCompleted = (username: string, response: CreateResponse): IAccountsAction => {
    const accessToken = response.AccessToken
    const extraInfo = response.ExtraInfo
    const op = OperationStatus.fromResponse(response)
    return {
      type: ActionTypes.USER_CREATE_COMPLETED,
      account: { username, accessToken, extraInfo, op }
    }
  }

  private userCreateFailed(username: string, reason: any): IAccountsAction {
    return {
      type: ActionTypes.USER_CREATE_FAILED,
      account: { username, op: genericFailure(reason) }
    }
  }
}

const AccountsActions = new AccountsActionCreator()

export {
  AccountsActions,
  AccountsActionCreator,
  CreateResponse
}



// WEBPACK FOOTER //
// ./src/app/redux/Accounts/actions/index.ts